import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { useState } from 'react';

import AudioSvg from '@/components/Icon/svgs/audio.svg';
import RightSvg from '@/components/Icon/svgs/right_share.svg';
import VoiceSettingsModal from '@/layouts/PA-Layout/VoiceModal';

import styles from './index.less';

interface IProps {
  className?: string;
}

const VoiceBtn = (props: IProps) => {
  const { className } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={classNames(styles.container, className)} onClick={() => setOpen(true)}>
        <div className={styles.iconWrapper}>
          <Icon className={styles.icon} component={AudioSvg} />
        </div>
        <div className={styles.text}>Voice</div>

        <Icon className={styles.rightIcon} component={RightSvg} />
      </div>

      <VoiceSettingsModal
        handleClose={() => setOpen(false)}
        handleConfirmCb={() => setOpen(false)}
        open={open}
      />
    </>
  );
};

export default VoiceBtn;
